// extracted by mini-css-extract-plugin
module.exports = {"main_wrapper":"MainWrapper_main_wrapper__1Guxu"};